// === MOBILE LOGO SIZE FIX (DT Theme – final) ===
(function () {

  function resizeLogo() {
    if (window.innerWidth <= 768) {
      document.querySelectorAll('#AccessibleNav .logo img').forEach(function (logo) {
        logo.style.setProperty('max-width', '90px', 'important');
        logo.style.setProperty('height', 'auto', 'important');
      });
    }
  }

  window.addEventListener('load', function () {
    resizeLogo();
    setTimeout(resizeLogo, 500);
  });

  window.addEventListener('resize', resizeLogo);

})();
// === MOBILE PRODUCT GALLERY DOTS (Swiper) ===
(function () {

  function enableMobileDots() {
    if (window.innerWidth > 768) return;

    document.querySelectorAll('.swiper-container').forEach(function (container) {

      // Nur wenn Pagination existiert
      var pagination = container.querySelector('.swiper-pagination');
      if (!pagination) return;

      // Verhindert doppelte Initialisierung
      if (container.classList.contains('dots-enabled')) return;
      container.classList.add('dots-enabled');

      // Swiper neu initialisieren / erweitern
      if (container.swiper) {
        container.swiper.params.pagination = {
          el: pagination,
          clickable: true
        };
        container.swiper.pagination.init();
        container.swiper.pagination.render();
        container.swiper.pagination.update();
      }
    });
  }

  window.addEventListener('load', function () {
    setTimeout(enableMobileDots, 300);
  });

})();
/* =========================================
   DT THEME – HIDE STICKY ATC WHEN CART OPENS
   basiert auf body class js-drawer-open
   ========================================= */
(function () {

  function toggleStickyATC() {
    const sticky = document.querySelector('.mobile-sticky-atc');
    if (!sticky) return;

    if (
      document.body.classList.contains('js-drawer-open') ||
      document.body.classList.contains('js-drawer-open-right')
    ) {
      sticky.style.display = 'none';
    } else {
      sticky.style.display = 'block';
    }
  }

  // Initial
  document.addEventListener('DOMContentLoaded', toggleStickyATC);

  // Beobachte body class changes (DT öffnet Drawer per Class)
  const observer = new MutationObserver(toggleStickyATC);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

})();
/* =====================================================
   MOBILE STICKY ATC
   nur anzeigen, wenn Haupt-ATC NICHT im Viewport ist
   DT Theme – stabil & performant
   ===================================================== */
(function () {

  if (window.innerWidth > 768) return;

  const stickyATC = document.querySelector('.mobile-sticky-atc');
  const mainATC = document.querySelector('.product-form__item--submit');

  if (!stickyATC || !mainATC) return;

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top < window.innerHeight &&
      rect.bottom > 0
    );
  }

  function updateStickyVisibility() {

    // Wenn Cart Drawer offen → Sticky immer aus
    if (
      document.body.classList.contains('js-drawer-open') ||
      document.body.classList.contains('js-drawer-open-right')
    ) {
      stickyATC.style.display = 'none';
      return;
    }

    // Haupt-ATC sichtbar → Sticky aus
    if (isInViewport(mainATC)) {
      stickyATC.style.display = 'none';
    } 
    // Haupt-ATC nicht sichtbar → Sticky an
    else {
      stickyATC.style.display = 'block';
    }
  }

  // Initial
  document.addEventListener('DOMContentLoaded', updateStickyVisibility);

  // Scroll + Resize
  window.addEventListener('scroll', updateStickyVisibility, { passive: true });
  window.addEventListener('resize', updateStickyVisibility);

})();




